// extracted by mini-css-extract-plugin
module.exports = {"cards":"Dashboard_cards__21VWw","cardHolder":"Dashboard_cardHolder__2nXB-","nameText":"Dashboard_nameText__J0TSk"};